<template>
  <div class="vehicle-select">
    <StepHeader
      title="Get Approved for a Car You Want at a Price You Can Afford"
      subtitle="What Type of Vehicle Do You Want?"
    />

    <StepContent
      width="md"
    >
      <AppButtonList
        :columns="2"
        :buttons="buttons"
        :value="car_type"
        @input="handleClick($event)"
      />
    </StepContent>

    <StepFooter>
      <AppButtonContinue
        v-data-layer
        :data-layer="[datalayerContinue, datalayerButtonList]"
        @click="$emit('next')"
      >
        Continue
      </AppButtonContinue>

    </StepFooter>
  </div>
</template>

<script>
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import AppButtonList from '@/components/common/buttons/AppButtonList'
import StepContent from '@/components/common/step/StepContent'
import StepFooter from '@/components/common/step/StepFooter'
import StepHeader from '@/components/common/step/StepHeader'

export default {
  // Name
  name: 'vehicle-select',

  // Components
  components: {
    AppButtonContinue,
    AppButtonList,
    StepContent,
    StepFooter,
    StepHeader
  },

  // Data
  data () {
    return {
      fieldName: 'car_type',
      datalayerStepName: 'vehicle_type',
      defaultSelected: true,
      buttons: [{
        text: 'Car',
        imgSrc: require('@/assets/img/vehicles/car.jpg'),
        value: 'Car',
        datalayer: 'car'
      }, {
        text: 'Truck',
        imgSrc: require('@/assets/img/vehicles/truck.jpg'),
        value: 'Truck',
        datalayer: 'truck'
      }, {
        text: 'SUV',
        imgSrc: require('@/assets/img/vehicles/suv.jpg'),
        value: 'SUV',
        datalayer: 'suv'
      }, {
        text: 'Van',
        imgSrc: require('@/assets/img/vehicles/van.jpg'),
        value: 'Van',
        datalayer: 'van'
      }]
    }
  },

  // Computed
  computed: {
    car_type () {
      return this.$store.state.application[this.fieldName]
    },

    datalayerContinue () {
      return `${this.datalayerStepName}_continue`
    },

    selectedButton () {
      if (!this.car_type) return
      for (let i in this.buttons) {
        if (this.buttons[i].value === this.car_type) {
          return this.buttons[i]
        }
      }
    },

    datalayerButtonList () {
      if (!this.selectedButton) return
      const datalayer = this.selectedButton.datalayer
      return `${this.datalayerStepName}_${datalayer}${this.defaultSelected ? '_default' : ''}`
    }
  },

  // Created
  created () {
    if (!this.car_type) {
      this.$store.updateApplication(
        this.fieldName,
        this.buttons[0].value
      )
    } else {
      this.defaultSelected = false
    }
  },

  // Methods
  methods: {
    handleClick (event) {
      this.$store.updateApplication(this.fieldName, event)
      this.defaultSelected = false
    }
  }
}
</script>

<style lang="scss">
.vehicle-select {
  .step-header {
    max-width: 305px;
    margin: auto;

    @include breakpoint('tablet-portrait-up') {
      max-width: 420px;
    }

    @include breakpoint('desktop-up') {
      max-width: 580px;
    }
  }
}
</style>
